import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in Dutch. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardNl: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Hallo, {name}",
  "dashboard.subtitle": "{date} · in Conakry",
  "dashboard.generatedAt": "Cijfers gelezen om {time} (tot een minuut vertraging).",
  "dashboard.refresh": "Vernieuwen",
  "dashboard.refreshing": "Vernieuwen…",
  "dashboard.loading": "Dashboard laden…",
  "dashboard.loadFailed": "Het dashboard kon niet worden geladen.",
  "dashboard.alertsAria": "Nu af te handelen",
  "dashboard.alert.open": "Openen →",
  "dashboard.alert.critical_report_open.tag": "Kritiek",
  "dashboard.alert.critical_report_open.text": "{count} kritieke melding(en) open.",
  "dashboard.alert.critical_report_open.review":
    "{count} persoon/personen geschorst tot een beslissing van het team; eerste herbeoordeling vóór {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Herbeoordeling te laat",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} schorsing(en) voorbij de herbeoordelingstermijn (de oudste: {date}). De personen blijven geschorst tot uw beslissing.",
  "dashboard.alert.cases_past_deadline.tag": "Te laat",
  "dashboard.alert.cases_past_deadline.text":
    "{count} dossier(s) voorbij de termijn voor een eerste antwoord ({hours} u).",
  "dashboard.alert.thin_coverage.tag": "Aanbod",
  "dashboard.alert.thin_coverage.text":
    "{trade} in {city}: vandaag {requests} aanvragen voor {pros} beschikbare pro('s). Daar moet worden geworven.",
  "dashboard.alert.failed_payments.tag": "Betalingen",
  "dashboard.alert.failed_payments.text": "{count} mislukte Orange Money-betaling(en) vandaag.",

  "dashboard.card.demand": "Aanvragen van vandaag",
  "dashboard.card.demand.answered": "Beantwoord binnen {hours} u",
  "dashboard.card.demand.unanswered": "Zonder antwoord",
  "dashboard.card.demand.expired": "Verlopen",
  "dashboard.card.introductions": "Contactleggingen",
  "dashboard.card.introductions.quotes": "Verzonden offertes",
  "dashboard.card.introductions.median": "Mediane tijd tot eerste antwoord",
  "dashboard.card.introductions.cancelled": "Geannuleerd vóór contactlegging",
  "dashboard.card.pros": "Geverifieerde pro's",
  "dashboard.card.pros.unit": "actief",
  "dashboard.card.pros.new": "Nieuw in 7 dagen",
  "dashboard.card.pros.waiting": "Wachtend op verificatie",
  "dashboard.card.pros.suspended": "Geschorst",
  "dashboard.card.money": "Geïnde kosten",
  "dashboard.card.money.failed": "Mislukte Orange Money-betalingen",
  "dashboard.card.money.approvals": "Openstaande goedkeuringsverzoeken",
  "dashboard.card.money.subscriptions": "Actieve maandabonnementen",

  "dashboard.coverage": "Dekking per vak en gemeente",
  "dashboard.coverage.empty": "Vandaag geen aanvragen.",
  "dashboard.coverageFoot":
    "In rood: minder dan de helft van de aanvragen op tijd beantwoord. Daar moet worden geworven.",
  "dashboard.col.trade": "Vak",
  "dashboard.col.commune": "Gemeente",
  "dashboard.col.requests": "Aanvragen",
  "dashboard.col.pros": "Beschikbare pro's",
  "dashboard.col.answered": "Beantwoord < {hours} u",

  "dashboard.queues": "Wachtrijen",
  "dashboard.noQueues": "Geen wachtrij voor uw rollen.",
  "dashboard.queue.late_cases": "Te late dossiers",
  "dashboard.queue.open_cases": "Open dossiers",
  "dashboard.queue.open_cases.meta": "{count} niet toegewezen",
  "dashboard.queue.identity_verifications": "Identiteitsverificaties",
  "dashboard.queue.identity_verifications.meta": "de oudste wacht al {age}",
  "dashboard.queue.safety_reports": "Open meldingen",
  "dashboard.queue.severity.critical": "{count} kritiek",
  "dashboard.queue.severity.high": "{count} hoog",
  "dashboard.queue.severity.medium": "{count} middel",
  "dashboard.queue.severity.low": "{count} laag",
  "dashboard.queue.overdue_suspension_reviews": "Te late herbeoordelingen van schorsingen",
  "dashboard.queue.overdue_suspension_reviews.meta": "nog steeds geschorst tot een beslissing",
  "dashboard.queue.payment_approvals": "Goedkeuringsverzoeken",
};
